import React from 'react';
import { SvgProps } from '../icon.types';

function HightTempIcon({ fillColor = '#2D3049' }: SvgProps) {
  return (
    <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg">
      <defs />
      <path
        d="M9 1c2.1333333 0 3.8905418 1.69256198 3.9950803 3.80114089L13 5v7.537c1.225 1.099 2 2.689 2 4.463 0 3.313-2.687 6-6 6s-6-2.687-6-6c0-1.6806316.69556787-3.1961219 1.81036594-4.2854381L5 12.537V5c0-2.2 1.8-4 4-4zm0 2c-1.05286364 0-1.91802893.81730785-1.99450498 1.85093266L7 5v8.43l-.665.595C5.486 14.787 5 15.871 5 17c0 2.206 1.794 4 4 4s4-1.794 4-4c0-1.0537333-.42336-2.0682667-1.1700764-2.8183887L11.665 14.025 11 13.43V5c0-1.103-.897-2-2-2zm1 2.0003v10.277c.596.347 1 .984 1 1.723 0 1.104-.896 2-2 2s-2-.896-2-2c0-.739.404-1.376 1-1.723V5.0003h2zM19 4v2h2v2h-2v2h-2V8h-2V6h2V4h2z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { HightTempIcon };
